import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import { ChildrenPropType } from '../../../../prop-types/children';
import { useFulfillmentRestrictionsByFPId } from '../../../../hooks/entities/selectors/fulfillment-plans';
import { useSalesOrderRestrictionsBySOId } from '../../../../hooks/entities/selectors/sales-orders';

const FulfillmentPlanRestrictionsContext = React.createContext({});

export const useFulfillmentPlanRestrictionsContext = () => useContext(FulfillmentPlanRestrictionsContext);

export const FulfillmentPlanRestrictionsContextProvider = ({ children, fulfillmentPlanId, salesOrderId }) => {
  const fulfillmentPlanRestrictions = useFulfillmentRestrictionsByFPId(fulfillmentPlanId);
  const salesOrderRestrictions = useSalesOrderRestrictionsBySOId(salesOrderId);

  const restrictions = useMemo(
    () => ({
      ...salesOrderRestrictions,
      ...fulfillmentPlanRestrictions,
    }),
    [fulfillmentPlanRestrictions, salesOrderRestrictions],
  );

  return <FulfillmentPlanRestrictionsContext.Provider value={restrictions}>{children}</FulfillmentPlanRestrictionsContext.Provider>;
};

FulfillmentPlanRestrictionsContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
  fulfillmentPlanId: PropTypes.string.isRequired,
  salesOrderId: PropTypes.string,
};
